
export default (text) => {
  if (!text) return '';

  const splitText = text.split(' ');
  const capitalizedText = splitText.map((word) => {
    if (!word.match(/(I{2})/g)) {
      return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
    }
    return word;
  });

  return capitalizedText.join(' ');
};
